/**
 * @generated SignedSource<<e1aa2d1276f6a90b039a1210d566149e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignMultipleSkillsToSkillCategoryInput = {
  categoryId?: string | null;
  skillIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type assignMultipleSkillsToSkillCategoryMutation$variables = {
  input: AssignMultipleSkillsToSkillCategoryInput;
};
export type assignMultipleSkillsToSkillCategoryMutation$data = {
  readonly assignMultipleSkillsToSkillCategory: {
    readonly skills: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly category: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type assignMultipleSkillsToSkillCategoryMutation = {
  variables: assignMultipleSkillsToSkillCategoryMutation$variables;
  response: assignMultipleSkillsToSkillCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignMultipleSkillsToSkillCategoryPayload",
    "kind": "LinkedField",
    "name": "assignMultipleSkillsToSkillCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Skill",
        "kind": "LinkedField",
        "name": "skills",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignMultipleSkillsToSkillCategoryMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignMultipleSkillsToSkillCategoryMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bcb774e846fb3d7d811c20ad62ab88ac",
    "id": null,
    "metadata": {},
    "name": "assignMultipleSkillsToSkillCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation assignMultipleSkillsToSkillCategoryMutation(\n  $input: AssignMultipleSkillsToSkillCategoryInput!\n) {\n  assignMultipleSkillsToSkillCategory(input: $input) {\n    skills {\n      id\n      name\n      category {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "81665c15e41daf3a50cc6f49f6d0fac0";

export default node;
